import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import FileOpenIcon from "@mui/icons-material/FileOpen";
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import { Box, Grid, Tooltip } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { format, parseISO } from "date-fns";
import { StyledEstablecimientos } from '../../../../styled/Prevencion';

const formatDate = (value) => {
  if (!value) return "";
  if (typeof value === "string" && value.includes("-")) {
    try {
      return format(parseISO(value), "dd/MM/yyyy");
    } catch (e) {
      return value;
    }
  }
  return value;
};

const mapEstadoToString = (estado) => {
  switch (estado) {
    case 0: return "Finalizado";
    case 2: return "En revisión";
    case 3: return "Observado";
    default: return estado;
  }
};

const FormulariosPresentacionCard = ({
  data = [],
  handleVerFormulario = () => { },
  handleEditarFormulario = () => { },
  handleCertificado = () => { }
}) => {
  const theme = useTheme();

  const getIconosSegunEstado = (formulario) => {
    let actions = [];
    const estado = formulario.estado;

    // Certificado: Para Res 81 (asumido codigoArtFormulario === 15) siempre se muestra
    actions.push(
      <StyledEstablecimientos.IconPadding key="certificado">
        <Tooltip title="Certificado de presentación" arrow>
          <BookmarkBorderOutlinedIcon
            onClick={() => handleCertificado(formulario)}
            sx={{ color: theme.palette.quartary.light, cursor: 'pointer' }}
          />
        </Tooltip>
      </StyledEstablecimientos.IconPadding>
    );
    
    // Editar: Se muestra si estado === 2 (Revisión)
    if (estado === 2) {
      actions.push(
        <StyledEstablecimientos.IconPadding key="editar">
          <Tooltip title="Editar Formulario" arrow>
            <NoteAltOutlinedIcon
              onClick={() => handleEditarFormulario(formulario)}
              sx={{ color: theme.palette.senary.light, cursor: 'pointer' }}
            />
          </Tooltip>
        </StyledEstablecimientos.IconPadding>
      );
    }
    
    // Visualizar: Se muestra si estado === 2 (Revisión), 0 (Finalizado) o 3 (Observado)
    if (estado === 0 || estado === 2 || estado === 3) {
      actions.push(
        <StyledEstablecimientos.IconPadding key="visualizar">
          <Tooltip title="Visualizar formulario" arrow>
            <FileOpenIcon
              onClick={() => handleVerFormulario(formulario)}
              sx={{ color: theme.palette.secondary.light, cursor: 'pointer' }}
            />
          </Tooltip>
        </StyledEstablecimientos.IconPadding>
      );
    }

    return actions.length === 0 ? null : actions;
  };

  return (
    <Box>
      {data?.length > 0 ? (
        data.map((formulario) => {
          let iconosSegunEstado = getIconosSegunEstado(formulario);
          return (
            <StyledEstablecimientos.Card
              elevation={2}
              key={formulario?.idDDJJ415 ?? Math.random()}
            >
              <Grid container spacing={2}>
                <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
                  <StyledEstablecimientos.FormularioText variant="body1" estado={formulario?.estado}>
                    {formatDate(formulario?.fechaPresentacion)}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                  <StyledEstablecimientos.FormularioText variant="body1" estado={formulario?.estado}>
                    {formulario?.establecimiento}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                  <StyledEstablecimientos.FormularioText variant="body1" estado={formulario?.estado}>
                    {formulario?.domicilio}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <StyledEstablecimientos.FormularioText estado={formulario?.estado}>
                    {formulario?.matrizUnica}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <StyledEstablecimientos.FormularioText estado={formulario?.estado}>
                    {formulario?.codigoEstablecimiento}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <StyledEstablecimientos.FormularioText estado={formulario?.estado}>
                    {formulario?.establecimientoSRT}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <StyledEstablecimientos.FormularioText estado={formulario?.estado}>
                    {formulario?.esDeTerceros}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <StyledEstablecimientos.FormularioText estado={formulario?.estado}>
                    {(formulario?.fechaBaja && formulario?.fechaBaja.startsWith("0001")) ? "" : formatDate(formulario?.fechaBaja)}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <StyledEstablecimientos.FormularioText estado={formulario?.estado}>
                    {mapEstadoToString(formulario?.estado)}
                  </StyledEstablecimientos.FormularioText>
                </Grid>
                <Grid
                  item
                  xs={1}
                  sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
                >
                  {iconosSegunEstado}
                </Grid>
              </Grid>
            </StyledEstablecimientos.Card>
          );
        })
      ) : (
        <StyledEstablecimientos.EmptyState variant="body2">
          No hay formularios para esta presentación
        </StyledEstablecimientos.EmptyState>
      )}
    </Box>
  );
};

export default FormulariosPresentacionCard;
